import React, { Component } from 'react';
import { Typography, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar, IconButton, Card, Box, Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import InputText from '../../../commonModules/interface/form-input-inline';
import PopUp from '../../../commonModules/interface/PopUp';
import Currency from '../../../commonModules/Currency';
import { CloseRounded, SearchRounded } from '@material-ui/icons';
import { isEmpty, size } from 'lodash';
import { Alert } from '@material-ui/lab';
import IncomeDetails from './IncomeDetails';
import LinkIncome from './LinkIncome';


class LinkPaymentPopUp extends Component {
    state = { 
    }

    render() {
        const { PAYMENTS, checkedPayments, handleChange, incomeID, getIncomeInfo, handleSubmitLink, totalPay, handleClose} = this.props;
        return (
            <LinkIncome
                title="Pointer les paiements "
                handleChange={handleChange}
                incomeID={incomeID}
                getIncomeInfo={getIncomeInfo}
                handleSubmitLink={handleSubmitLink}
                totalPay={totalPay}
                handleClose={handleClose}
            >
                {(checkedPayments && Array.isArray(checkedPayments) ? checkedPayments : []).map( (payID, index) => 
                    <ListItem key={payID}>
                        <ListItemAvatar onClick={() => this.props.rmPayment(payID)} style={{ cursor: "pointer"}}>
                            <CloseRounded color="error" />
                        </ListItemAvatar>
                        <ListItemText 
                            primary={PAYMENTS[payID].userName}
                            secondary={new Date(PAYMENTS[payID].timePayment).toLocaleString('fr-FR')}
                        />
                        <ListItemSecondaryAction>
                            <ListItemText secondary={<Currency value={PAYMENTS[payID].money} />} />
                        </ListItemSecondaryAction>
                    </ListItem>
                )}
            </LinkIncome>                    
        );
    }
}

export default LinkPaymentPopUp;